import inboxCountReducer from "./inboxCountReducer";

const inboxCountReducers = {
    inboxCount : inboxCountReducer
}

export default inboxCountReducers